<template>
	<main class="qly-main">
		<div class="qly-location">
			<el-breadcrumb>
				<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item v-for="(item, index) in breadList" :key="index">{{item.meta.title}}
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="qly-content">
			<router-view />
		</div>
	</main>
</template>

<script>
	export default {
		props: {
			isCollapse: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				breadList: []
			}
		},
		watch: {
			$route(route) {
				this.getBreadList(route);
			}
		},
		created() {
			this.getBreadList(this.$route);
		},
		methods: {
			getBreadList(val) {
				// 过滤路由matched对象
				if (val.matched) {
					let matched = val.matched.filter(item => item.meta && item.meta.title);
					// 拿到过滤好的路由v-for遍历出来
					this.breadList = matched;
				}
			},

		}

	};
</script>

<style lang="scss">
	.qly-main {
		height: 100%;
		width: 100%;
		margin: 0 5px;
		box-sizing: border-box;
		overflow: hidden;

		.qly-location {
			height: 60px;
			margin-bottom: 5px;
			display: flex;
			align-items: center;
			padding-left: 20px;
			box-sizing: border-box;
		}

		.qly-content {
			height: calc(100% - 65px);
			padding: 0 20px 10px 20px;
			box-sizing: border-box;
		}
	}

	.qly-main .qly-content {
		height: calc(100% - 65px);
		padding: 0 20px 10px 20px;
		box-sizing: border-box;
		overflow: auto;
	}
</style>